export class BaseRequest {
    MetaData: Record<string, string> | null
    BotIdentifier: string | null
    ClusterName: string | null
}